import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "@popperjs/core";
import "@qinvent/map/dist/qimap.css";
import App from "./App";
import { store } from "./reduxStore/store";
import "./style/App.scss";

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </BrowserRouter>
  </Provider>
);

const root = createRoot(document.getElementById("root"));
root.render(app);
